// extracted by mini-css-extract-plugin
export default {"app":"CustomLaserImg_app__R1UIU","cuff1":"CustomLaserImg_cuff1__jVThc","cufflinks":"CustomLaserImg_cufflinks__HEBLS","tiebar":"CustomLaserImg_tiebar__ZBEr-"};